import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './ErrorBox.module.css';

/**
 * ErrorBox - A reusable error message container
 * 
 * Displays validation errors or error messages in a styled box with bullet points.
 * Designed to match the Figma design specifications.
 * 
 * @example
 * // Single error
 * <ErrorBox errors={['Widget name is required']} />
 * 
 * @example
 * // Multiple errors
 * <ErrorBox errors={[
 *   'Widget name is required',
 *   'Please select a widget type',
 *   'Data source configuration is incomplete'
 * ]} />
 * 
 * @example
 * // Custom styling
 * <ErrorBox 
 *   errors={['Error message']} 
 *   className="my-custom-class"
 * />
 */
function ErrorBox({ errors, className }) {
  // Don't render if no errors
  if (!errors || errors.length === 0) {
    return null;
  }

  return (
    <div className={`${styles.errorBox} ${className || ''}`}>
      {errors.map((error) => (
        <div key={error} className={styles.errorItem}>
          <span className={styles.errorBullet}>•</span>
          <span className={styles.errorText}>{error}</span>
        </div>
      ))}
    </div>
  );
}

ErrorBox.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
};

ErrorBox.defaultProps = {
  errors: [],
  className: '',
};

export default ErrorBox;

